import React from 'react';
import '../App.css';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';

const Checkout = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <section className="checkout-page">
        <h2>Checkout</h2>
        <div className="checkout-msg">
          Debes iniciar sesión para finalizar tu compra.
          <button className="checkout-login-btn" onClick={() => navigate('/login')}>Iniciar sesión</button>
        </div>
      </section>
    );
  }

  return (
    <section className="checkout-page">
      <h2>Checkout</h2>
      {/* Placeholder para formulario de datos de usuario */}
      <form className="checkout-form-placeholder">
        <input type="text" placeholder="Nombre completo" required />
        <input type="email" placeholder="Correo electrónico" required />
        <input type="text" placeholder="Dirección de envío" required />
        <input type="tel" placeholder="Teléfono" />
      </form>
      {/* Placeholder para resumen y botón de pago */}
      <div className="checkout-resumen-placeholder">
        <div className="checkout-total">Total a pagar: $0.00</div>
        <button className="checkout-pagar-btn">Pagar con MercadoPago</button>
      </div>
    </section>
  );
};

export default Checkout; 